

require('../shipping-address/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoAddShipping', function () {
    return {
        template: _template2['default'],
        scope: {
            auth: '=?',
            token: '=?',
            doneFn: '=?',
            sidebar: '=?',
            update: '=?',
            renderBillingAddCheckbox: '=?',
            shippingChangeFeature: '=?',
            backUri: '=?'
        },
        controller: function controller() {}
    };
});


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-member-components/src/select-shipping/add-shipping/directive.js
// module id = ../node_modules/xo-member-components/src/select-shipping/add-shipping/directive.js
// module chunks = 0